// function getRandomHexColor(): string {
//   return `#${Math.floor(Math.random() * 0xffffff)
//     .toString(16)
//     .padStart(6, '0')}`;
// }
// export function generateColors(length: number, returnType: 'string' | 'array') {
//   const generateHandler = getRandomHexColor;
//   if (returnType === 'string' && length > 1) return generateHandler();
//   if (returnType === 'string' && length === 1) {
//     return generateHandler();
//   }
//   let start = 0;
//   const result: string[] = [];
//   while (start < length) {
//     result.push(generateHandler());
//     start++;
//   }
//   return result;
// }
function getRandomHexColor(): string {
  return `#${Math.floor(Math.random() * 0xffffff)
    .toString(16)
    .padStart(6, '0')}`;
}

export function generateColors(length: number, returnType: 'string'): string;

export function generateColors(length: number, returnType: 'array'): string[];

export function generateColors(length: number, returnType: 'string' | 'array') {
  if (returnType === 'string') {
    return getRandomHexColor();
  }

  const result: string[] = [];

  for (let i = 0; i < length; i++) {
    result.push(getRandomHexColor());
  }

  return result;
}
